module.exports = __webpack_public_path__ + "static/media/forrest.412d9ec6.jpg";